import React from 'react';
import { motion } from 'framer-motion';
import { Clock, RotateCcw, Target, Heart, Shield } from 'lucide-react';
const audiences = [{
  icon: Clock,
  title: 'Personas ocupadas',
  desc: 'Que no tienen tiempo para pasar horas en un gimnasio.'
}, {
  icon: RotateCcw,
  title: 'Personas que ya intentaron antes',
  desc: 'Y necesitan un método simple que realmente puedan mantener.'
}, {
  icon: Target,
  title: 'Principiantes',
  desc: 'Que quieren empezar sin sentirse intimidados.'
}, {
  icon: Heart,
  title: 'Personas que buscan verse y sentirse mejor',
  desc: 'Más energía, más confianza y mejores hábitos.'
}, {
  icon: Shield,
  title: 'Hombres y mujeres que quieren disciplina real',
  desc: 'Sin métodos extremos ni presión innecesaria.'
}];
export function TargetAudience() {
  return <section className="py-24 px-4 bg-dark relative" data-id="element-164">
      <div className="max-w-6xl mx-auto" data-id="element-165">
        <div className="text-center mb-16" data-id="element-166">
          <h2 className="text-5xl md:text-6xl font-display uppercase text-white mb-6" data-id="element-167">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-168">
            Diseñado para personas reales que quieren transformar su vida desde
            casa
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-169">
          {audiences.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-dark-card border border-dark-border p-8 rounded-2xl flex flex-col items-center text-center ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-170">
              <div className="w-16 h-16 rounded-full bg-brand/10 flex items-center justify-center mb-6" data-id="element-171">
                <item.icon className="w-8 h-8 text-brand" data-id="element-172" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-173">
                {item.title}
              </h3>
              <p className="text-gray-400" data-id="element-174">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}